export default "__VITE_ASSET__1f96c7f1__"